module.exports = __webpack_public_path__ + "img/slide-3.e1e02f46.png";